export default __webpack_public_path__ + "static/N0227-5171affa649793804dc8db364de17dc9.png";